import { ButtonPillSmall } from "@wix/wix-ui-icons-common";
import buttonDataDefaults from "./../ricos-schema/legacy/statics/button.defaults.json";
import { ButtonData_Type } from "./../ricos-schema/next-schema";
import {
  quickActionsModalSections,
  RicosPluginToolbarNames
} from "./../ricos-types";
import { changeSelectionToEndOfTextBlock } from "./../wix-rich-content-common";
import { actionButtonConverter, linkButtonConverter } from "./button-converters";
import { DEFAULT_CONFIG, SETTINGS_TAB } from "./constants";
import { DEFAULT_PALETTE } from "./defaults";
import { getAddButtons } from "./getAddButtons";
import { getToolbarButtons } from "./getToolbarButtons";
import ButtonSettingsModal from "./modals/SettingsModal";
import { tiptapExtensionsMap } from "./tiptap/tiptap";
import { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE } from "./types";
const pluginButton = ({
  config,
  type,
  toolbarName
}) => {
  return {
    config: { ...DEFAULT_CONFIG, ...config },
    type,
    pmMarkConverters: [],
    pmNodeConverters: type === LINK_BUTTON_TYPE ? [linkButtonConverter] : [actionButtonConverter],
    toolbar: {
      names: [toolbarName],
      getButtons: (config2, services) => getToolbarButtons(config2, services, type)
    },
    getAddButtons: (config2, services) => getAddButtons(config2, services, type),
    tiptapExtensions: tiptapExtensionsMap({ disableResize: config?.disableResize ?? false })[type],
    __exports: {
      SettingsModal: ButtonSettingsModal,
      SETTINGS_TAB,
      DEFAULT_PALETTE
    }
  };
};
const pluginLinkButton = (config) => {
  return {
    ...pluginButton({
      type: LINK_BUTTON_TYPE,
      config,
      toolbarName: RicosPluginToolbarNames.LINK_BUTTON
    }),
    getQuickActions: () => [
      {
        id: "button",
        icon: ButtonPillSmall,
        title: "QuickActionsPlugin_ActionTitle_Button",
        section: quickActionsModalSections.FormatLayout,
        tags: ["action", "link", "call-to-action", "interactive", "clickable"],
        command: ({ publicCommands, editor }) => {
          changeSelectionToEndOfTextBlock(editor);
          publicCommands.insertBlockWithBlankLines(LINK_BUTTON_TYPE, {
            ...buttonDataDefaults,
            // @ts-expect-error
            type: ButtonData_Type.LINK
          });
        }
      }
    ]
  };
};
const pluginActionButton = (config) => {
  return pluginButton({
    type: ACTION_BUTTON_TYPE,
    config,
    toolbarName: RicosPluginToolbarNames.ACTION_BUTTON
  });
};
export {
  pluginActionButton,
  pluginLinkButton
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
